import React from 'react';
import { toDisplayDate } from '../../../../utils';

export const MfgTable = ({ column, data, clickHandler, dyeing, ready_status }) => {
  const filteredColumn = dyeing ? column.filter((col) => !col.hideIfDye) : column;
  return (
    <table className="w-100">
      <thead>
        <tr>
          {filteredColumn.map((col, index) => (
            <th key={index} className="text-center">
              {col.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr
            className="text-center"
            key={rowIndex}
            style={{ cursor: 'pointer', color: 'black', fontSize: '12px', fontWeight: '600' }}>
            {filteredColumn.map((col, colIndex) => {
              const isDash =
                col.name === 'Action' &&
                ready_status === 'Not Ready' &&
                data[rowIndex]?.state !== 'packed';

              const shouldClick =
                col.isClickable &&
                !isDash &&
                (row?.order_unit > row?.ready_unit ||
                  (row?.order_unit <= row?.ready_unit && row?.state === 'packed'));

              return (
                <td
                  key={colIndex}
                  className={col.classNameTD}
                  onClick={shouldClick ? (e) => clickHandler({ row, e }) : undefined}>
                  {isDash
                    ? '-'
                    : col.isCustom
                      ? col.customFormatter(
                          col.dataField.reduce((acc, field) => {
                            acc[field] = row[field];
                            return acc;
                          }, {}),
                        )
                      : col.isDate
                        ? toDisplayDate(row[col.dataField])
                        : row[col.dataField]}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
